import { request } from "../_helpers/Auth";

const namespace = "/api";

export const createUser = (payload) => {
    return request({
        url: namespace + "/user/create",
        method: "post",
        data: payload,
    });
};

export const registerUser = (payload) => {
    return request({
        url: namespace + "/user/register",
        method: "post",
        data: payload,
    });
};

export const updateMail = (payload) => {
    return request({
        url: namespace + "/user/alarm",
        method: "post",
        data: payload,
    });
};

export const updateDefaultPage = (payload) => {
    return request({
        url: namespace + "/user/default-page",
        method: "post",
        data: payload,
    });
};

export const editPassword = (payload, id) => {
    return request({
        url: namespace + "/user/password/edit/" + id,
        method: "post",
        data: payload,
    });
};

export const updateUserPhone = (payload, user_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/phone",
        method: "post",
        data: payload,
    });
};

export const getUserPhone = (user_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/phone",
        method: "get",
    });
}